import debug from 'debug';
import InlineView from 'Minetilbud/Shared/Components/inline-view/inline-view';

const log = debug('Navigation');

class PrimaryNavigation {
	constructor(element) {
		this.element = element;

		this.initialize();
	}

	initialize() {
		if (InlineView.isEnabled()) {
			this.element.classList.add('is-inline-view');
		} else {
			this.element.classList.remove('is-inline-view');
		}

		// Given the precense of a special data attribute on the page, set the corresponding data attribute on the body tag
		// to mark the entire page as a NT+ page.
		if (this.isNejTakPlusPage()) {
			document.body.setAttribute('data-page-nejtakplus', true);
		}

		if (this.isFrontPage() || this.isSearchPage()) return;

		this.element.classList.remove('has-search-box');
	}

	/**
	 * @returns {boolean}
	 */
	 isFrontPage() {
		const page = document.body.getAttribute('data-page');
		if (page === 'frontpage') return true;
		return false;
	}

	/**
	 * @returns {boolean}
	 */
	isNejTakPlusPage() {
		const pageElement = document.querySelector('[data-js="PageIsNTPlus"]');
		if (pageElement === null) return false;

		return pageElement.getAttribute('data-page-nejtakplus') == 'true';
	}

	isSearchPage() {
		const page = document.body.getAttribute('data-page');
		if (page === 'tilbudssoegning') return true;
		return false;
	}
}

export default PrimaryNavigation;
